import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserDataContext } from "../components/UserDataContext";
import { Container } from "react-bootstrap";

import {
  Button,
  CircularProgress,
  Box,
  Typography,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";

import { apiRequest } from "../components/Config";
import Alerts from "../components/Alerts";

export default function ExperienceMenu() {
  const navigate = useNavigate();
  const { userData } = useContext(UserDataContext);

  const [aboutMe, setAboutMe] = useState("");
  const [loadingData, setLoadingData] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const [apiResponse, setApiResponse] = useState({});
  const [showApiResponse, setShowApiResponse] = useState(false);

  useEffect(() => {
    if (userData && Number(userData.group) !== 3) {
      navigate("/nopermission");
    }
  }, [userData, navigate]);

  useEffect(() => {
    const fetchUserText = async () => {
      if (!userData?.userId) return;

      setLoadingData(true);
      try {
        const response = await apiRequest("get-user-text", "GET");

        if (response.success) {
          setAboutMe(response.text || "");
        }
      } catch (error) {
        console.error("Błąd pobierania danych o użytkowniku:", error);
      } finally {
        setLoadingData(false);
      }
    };

    fetchUserText();
  }, [userData]);
  const handleSave = async () => {
    setIsSaving(true);
    setShowApiResponse(false);

    try {
      const payload = {
        userId: userData.userId,
        text: aboutMe,
      };

      const response = await apiRequest("user-text", "POST", payload);

      setApiResponse(
        response.success
          ? {
              title: "Sukces",
              severity: "success",
              info: "Zapisano zmiany pomyślnie.",
            }
          : {
              title: "Błąd",
              severity: "warning",
              info: "Nie udało się zapisać zmian.",
            },
      );

      setShowApiResponse(true);
    } catch (error) {
      setApiResponse({
        title: "Błąd połączenia",
        severity: "error",
        info: "Wystąpił problem podczas komunikacji z serwerem.",
      });
      setShowApiResponse(true);
    } finally {
      setIsSaving(false);
    }
  };

  const handleFinalize = async () => {
    setIsSaving(true);
    try {
      const payload = {
        status: 1,
      };

      const response = await apiRequest(
        "finalize-verification",
        "POST",
        payload,
      );

      if (response.success) {
        setOpenModal(false);
        navigate(`/portfolio/${userData.userId}`);
      } else {
        alert(response.message || "Wystąpił błąd.");
      }
    } catch (error) {
      console.error("Błąd połączenia:", error);
    } finally {
      setIsSaving(false);
    }
  };

  if (loadingData) {
    return (
      <Box display="flex" justifyContent="center" mt={10}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Container style={{ marginTop: "40px", marginBottom: "40px" }}>
      {showApiResponse && <Alerts data={apiResponse} />}

      <Typography variant="h4" mb={1}>
        Tu możesz krótko coś o sobie napisać, by osoba zamawiająca Twoje usługi
        wiedziała więcej.
      </Typography>

      <TextField
        fullWidth
        multiline
        rows={8}
        variant="outlined"
        placeholder="Opisz swoimi słowami siebie, by przyszły senior mógł Cię poznać bliżej"
        value={aboutMe}
        onChange={(e) => setAboutMe(e.target.value.substring(0, 1000))}
        helperText={`${aboutMe.length}/1000 znaków`}
        inputProps={{ maxLength: 1000 }}
        sx={{ mb: 3, backgroundColor: "#fff" }}
      />

      <Box sx={{ display: "flex", gap: 2 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSave}
          disabled={isSaving}
          startIcon={isSaving && <CircularProgress size={20} color="inherit" />}
        >
          {isSaving ? "Zapisywanie..." : "Zapisz zmiany"}
        </Button>

        <Button
          variant="contained"
          color="error"
          onClick={() => setOpenModal(true)}
        >
          Zakończ edycję i prześlij do weryfikacji
        </Button>
      </Box>

      <Dialog
        open={openModal}
        onClose={() => setOpenModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Potwierdzenie weryfikacji"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Czy na pewno chcesz zakończyć edycję? Spowoduje to zablokowanie
            możliwości dalszych zmian do czasu zakończenia weryfikacji przez
            administratora.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenModal(false)}>Anuluj</Button>
          <Button
            onClick={handleFinalize}
            autoFocus
            variant="contained"
            color="success"
          >
            Potwierdzam i wysyłam
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}
